{
  "quote": {
    "confirmDialog": {
      "name": "Name:",
      "description": "Description:",
      "validity": "This quote is valid until {{ expirationTime }}",
      "option": {
        "yes": "Yes",
        "no": "No"
      },
      "buyer": {
        "submit": {
          "a11y": {
            "close": "Close submit quote modal"
          },
          "title": "Submit Quote Request {{ code }}?",
          "confirmNote": "Are you sure you want to submit this quote request?",
          "successMessage": "Quote request submitted successfully"
        },
        "cancel": {
          "a11y": {
            "close": "Close cancel quote modal"
          },
          "title": "Cancel Quote Request {{ code }}?",
          "confirmNote": "Are you sure you want to cancel this quote request?",
          "successMessage": "Quote request cancelled"
        }
      },
      "buyer_offer": {
        "edit": {
          "a11y": {
            "close": "Close edit quote modal"
          },
          "title": "Confirm Edit Quote {{ code }}?",
          "confirmNote": "Are you sure you want to edit this approved quote?",
          "warningNote": "This Quote has been Approved. Editing this Quote will prevent Checkout until new edits are approved."
        },
        "cancel": {
          "a11y": {
            "close": "Close cancel quote modal"
          },
          "title": "Cancel Quote {{ code }}?",
          "confirmNote": "Are you sure you want to cancel this quote?",
          "successMessage": "Quote cancelled"
        },
        "checkout": {
          "a11y": {
            "close": "Close checkout quote modal"
          },
          "title": "Checkout Quote {{ code }}?",
          "confirmNote": "Are you sure you want to accept and checkout this quote?"
        }
      },
      "expired": {
        "edit": {
          "a11y": {
            "close": "Close edit quote modal"
          },
          "title": "Confirm Edit Quote {{ code }}?",
          "confirmNote": "Are you sure you want to edit this expired quote?",
          "warningNote": "This Quote is expired. Editing this quote will prevent checkout until new edits are approved."
        },
        "requote": {
          "a11y": {
            "close": "Close requote modal"
          },
          "title": "Recreate Quote Request {{ code }}?",
          "confirmNote": "Are you sure you want to recreate this quote request?",
          "warningNote": "This Quote is expired. Re-quoting it will create a new quote request with same contents, which can be edited and submitted for approval afterwards."
        }
      },
      "seller": {
        "submit": {
          "a11y": {
            "close": "Close submit quote modal"
          },
          "title": "Submit Quote {{ code }}?",
          "confirmNote": "Are you sure you want to submit this quote?",
          "warningNote": "Depending on the total value of the quote, an additional approval might be required before the buyer can check out this quote.",
          "successMessage": "Quote submitted successfully"
        }
      },
      "sellerapprover": {
        "approve": {
          "a11y": {
            "close": "Close approve quote modal"
          },
          "title": "Approve Quote {{ code }}?",
          "confirmNote": "Are you sure you want to approve this quote?",
          "successMessage": "Quote approved successfully"
        },
        "reject": {
          "a11y": {
            "close": "Close reject quote modal"
          },
          "title": "Reject Quote {{ code }}?",
          "confirmNote": "Are you sure you want to reject this quote?",
          "successMessage": "Quote rejected"
        }
      },
      "cancelled": {
        "requote": {
          "a11y": {
            "close": "Close requote modal"
          },
          "title": "Recreate Quote Request {{ code }}?",
          "confirmNote": "Are you sure you want to recreate this quote request?",
          "warningNote": "Your current cart will be converted to a saved cart."
        }
      },
      "all": {
        "edit": {
          "a11y": {
            "close": "Close edit quote modal"
          },
          "title": "Edit Quote {{ code }}?",
          "confirmNote": "Are you sure you want to edit this quote?",
          "warningNote": "Your current cart will be converted to a saved cart."
        }
      }
    },
    "comments": {
      "regionTitle": "Contact/Comment Box",
      "title": "Contact",
      "invalidComment": "Invalid Input - Please type again...",
      "allProducts": "All Products"
    },
    "commons": {
      "requestQuote": "Request Quote",
      "cart": "Cart",
      "minRequestInitiationNote": "Minimum ${{minValue}} subtotal is required to submit a quote ",
      "savedActiveCart": "Your active cart was converted to saved cart {{ code }}"
    },
    "header": {
      "buyerEdit": {
        "a11y": {
          "cancel": "Cancel editing quote header information",
          "save": "Save quote header information"
        }
      },
      "overview": {
        "regionTitle": "Quote details summary",
        "id": "Quote ID",
        "status": "Status",
        "information": "Quote Information",
        "name": "Name",
        "description": "Description",
        "charactersLeft": "characters left: {{count}}",
        "priceAndExpiry": "Price & Expiry",
        "estimatedTotal": "Estimated Total",
        "total": "Total",
        "expirationTime": "Expiry Date",
        "a11y": {
          "edit": "Edit quote header information"
        },
        "createdAndUpdated": "Created & Updated",
        "createdDate": "Created",
        "lastUpdatedDate": "Last Updated"
      }
    },
    "httpHandlers": {
      "cartValidationIssue": "Hay problemas con tus entradas. Por favor revisa tu carrito.",
      "quoteCartIssue": "No es posible hacer cambios en las entradas del carrito. Procede al pago",
      "absoluteDiscountIssue": "Elige un descuento que no exceda el valor total",
      "expirationDateIssue": "Elige una fecha de vencimiento en el futuro",
      "threshold": {
        "underThresholdError": "El precio total de la cotización solicitada no cumple con el monto mínimo"
      },
      "expired": "Esta cotización ha expirado. Debes volver a enviar tu solicitud de cotización para recibir otra cotización del proveedor."
    },
    "items": {
      "regionTitle": "Cart items"
    },
    "links": {
      "newCart": "New Cart",
      "quotes": "Quotes",
      "a11y": {
        "newCart": "Create new empty cart and navigate to it.",
        "quotes": "Navigate to quote search result list."
      }
    },
    "list": {
      "regionTitle": "Resumen de la lista de cotizaciones",
      "title": "Lista de Cotizaciones",
      "name": "Nombre",
      "updated": "Actualizado",
      "sortBy": "Ordenar por",
      "sortQuotes": "Ordenar Cotizaciones",
      "empty": "No tenemos registros de cotizaciones para esta cuenta.",
      "quoteId": "ID de Cotización",
      "status": "Estado",
      "clickableRow": "Haz clic en la fila para más detalles de la cotización"
    },
    "states": {
      "BUYER_DRAFT": "Borrador",
      "BUYER_SUBMITTED": "Enviado",
      "BUYER_ACCEPTED": "Aceptado",
      "BUYER_APPROVED": "Aprobado",
      "BUYER_REJECTED": "Rechazado",
      "BUYER_OFFER": "Cotización del Vendedor",
      "BUYER_ORDERED": "Ordenado",
      "SELLER_DRAFT": "Borrador",
      "SELLER_REQUEST": "Solicitado",
      "SELLER_SUBMITTED": "Enviado",
      "SELLERAPPROVER_DRAFT": "Borrador",
      "SELLERAPPROVER_PENDING": "Pendiente de Aprobación",
      "SELLERAPPROVER_APPROVED": "Aprobado",
      "SELLERAPPROVER_REJECTED": "Rechazado",
      "CREATED": "Creado",
      "CANCELLED": "Cancelado",
      "EXPIRED": "Expirado"
    },
    "summary": {
      "regionTitle": "Order Summary",
      "actions": {
        "APPROVE": "Approve Quote",
        "CANCEL": "Cancel Quote",
        "CHECKOUT": "Accept and Checkout",
        "EDIT": "Edit Quote",
        "REJECT": "Reject Quote",
        "REQUOTE": "Request new Quote",
        "SAVE": "Save Quote",
        "SUBMIT": "Submit Quote",
        "VIEW": "View Quote"
      },
      "prices": {
        "title": "Order Summary",
        "subtotal": "Subtotal",
        "productDiscount": "Item Discount",
        "orderDiscount": "Order Discount",
        "quoteDiscount": "Quote Discount",
        "total": "Total",
        "hint": "No taxes are included in the total"
      },
      "sellerEdit": {
        "discount": "Discount",
        "apply": "Apply",
        "expiryDate": "Expiry Date",
        "discountValidationText": "Enter a valid percentage discount",
        "a11y": {
          "apply": "Click to apply the entered discount value to this quote",
          "discount": "Enter a percentage discount value to be applied to this quote",
          "expiryDate": "Enter an expiry date for this quote"
        }
      }
    },
    "quoteHistory": {
      "quoteHistory": "Mis cotizaciones",
      "quoteId": "N.º DE COTIZACIÓN",
      "emptyPurchasequoteId": "None",
      "date": "Date",
      "status": "ESTADO",
      "PONumber": "P.O. Number",
      "total": "Total",
      "noquotes": "We have no quote records for this account.",
      "noReplenishmentquotes": "We have no replenishment quote records for this account.",
      "startShopping": "Start Shopping",
      "sortBy": "Ordenar",
      "sortquotes": "Sort quotes",
      "replenishmentquoteHistory": "Replenishment quote History",
      "replenishmentquoteId": "Replenishment #",
      "purchasequoteNumber": "PO #",
      "costCenter": "Cost Center",
      "startOn": "Start On",
      "frequency": "Frequency",
      "nextquoteDate": "Next quote Date",
      "cancel": "Cancel",
      "cancelled": "Cancelled",
      "replenishmentHistory": "Replenishment History",
      "notFound": "No quotes Found",
      "actions": "Actions",
      "creationDate": "FECHA DE CREACIÓN",
      "rut": "RUT EMPRESA",
      "nameEmpresa": "NOMBRE EMPRESA",
      "validUntil": "VÁLIDO HASTA"
    },
    "quoteDetails": {
      "deliveryStatus_IN_TRANSIT": "In Transit",
      "deliveryStatus_READY_FOR_PICKUP": "Ready for Pickup",
      "deliveryStatus_READY_FOR_SHIPPING": "Ready for Shipping",
      "deliveryStatus_WAITING": "Waiting",
      "deliveryStatus_DELIVERING": "Delivering",
      "deliveryStatus_PICKPACK": "Preparing for Shipment",
      "deliveryStatus_PICKUP_COMPLETE": "Pickup Complete",
      "deliveryStatus_DELIVERY_COMPLETED": "Delivery Complete",
      "deliveryStatus_PAYMENT_NOT_CAPTURED": "Payment Issue",
      "deliveryStatus_IN_PROCESS": "Order Processing",
      "deliveryStatus_READY": "Order Processing",
      "deliveryStatus_DELIVERY_REJECTED": "Delivery Rejected",
      "deliveryStatus_SHIPPED": "Shipped",
      "deliveryStatus_TAX_NOT_COMMITTED": "Tax Issue",
      "deliveryStatus_CANCELLED": "Cancelled",
      "statusDisplay_cancelled": "Cancelled",
      "statusDisplay_cancelling": "Cancel Pending",
      "statusDisplay_completed": "Completed",
      "statusDisplay_created": "Created",
      "statusDisplay_error": "Pending",
      "statusDisplay_Error": "Pending",
      "statusDisplay_processing": "En Proceso",
      "statusDisplay_open": "Open",
      "statusDisplay_pending": {
        "approval": "Pending Approval",
        "merchant": {
          "approval": "Pending Merchant Approval"
        }
      },
      "statusDisplay_approved": "Approved",
      "statusDisplay_rejected": "Rejected",
      "statusDisplay_merchant": {
        "approved": "Merchant Approved",
        "rejected": "Merchant Rejected"
      },
      "statusDisplay_assigned": {
        "admin": "Assigned To Administrator"
      },
      "statusDisplay_BUYER_OFFER": "Cotización del proveedor",
      "statusDisplay_BUYER_DRAFT": "Borrador",
      "statusDisplay_BUYER_SUBMITTED": "Enviado"
    }
  }
}
